import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styletron-react';
import { transitionDuration } from '../../const/transitionDuration';
import { transitionTimingFunction } from '../../const/transitionTimingFunction';
const StyledRotator = styled('div', (p) => ({
    transform: `rotate(${p.$rotationInDeg}deg)`,
    width: 'fit-content',
    lineHeight: 0,
    transitionProperty: 'transform',
    transitionDuration: transitionDuration.medium,
    transitionTimingFunction: transitionTimingFunction.ease,
}));
export const Rotator = ({ children, rotationInDeg }) => {
    return (_jsx(StyledRotator, { $rotationInDeg: rotationInDeg, children: children }));
};
